import { render, staticRenderFns } from "./Caracteristicas.vue?vue&type=template&id=2f43254c&scoped=true"
import script from "./Caracteristicas.vue?vue&type=script&lang=js"
export * from "./Caracteristicas.vue?vue&type=script&lang=js"
import style0 from "./Caracteristicas.vue?vue&type=style&index=0&id=2f43254c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43254c",
  null
  
)

export default component.exports